import { html, LitElement, PropertyValues } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import { state, property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';

@customElement('gz-progress-thin')
export class GzProgressThinWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/properties
  @property({
    type: Number,
    reflect: true,
  })
  valueNow = 0;

  @property({ type: Number })
  valueMax = 0;

  @property({ type: String })
  progressColor = 'var(--sky-blue-chart-050)';

  @property({ type: Boolean })
  animations = false;

  @state()
  private percentage = 0;

  @state()
  private minWidth = 0;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    const style = {
      width: `${this.percentage}%`,
      'min-width': `${this.minWidth}px`,
      'background-color': `${this.progressColor}`,
    };
    return html`
      <div class="progress-container-thin">
        <div class="progress-thin" style=${styleMap(style)}></div>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();

    /** When the component is added to the DOM we show the progress as
     *  empty, with valueNow = 0, then update the valueNow variable with the
     *  value passed from the component's parent. The width property on the
     *  progress element is animated and will show a smooth transition from 0 ->
     *  valueNow.
     */
    this.updateProgressBar(0, this.valueMax);

    setTimeout(() => {
      this.updateProgressBar(this.valueNow, this.valueMax);
    }, 800);
  }

  updated(_changedProperties: PropertyValues): void {
    if (_changedProperties.has('valueNow')) {
      this.updateProgressBar(this.valueNow, this.valueMax);
    }
  }

  updateProgressBar(value: number, total: number) {
    this.percentage = (100 * value) / total || 0;
    /**
     * if the progress value > 0 but is very small in comparison with the
     * total we need to set a minimum width of 1px for the progress bar so
     * it will be always visible even for very small values;
     */
    this.minWidth = value > 0 ? 1 : 0;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-progress-thin': GzProgressThinWebComponent;
  }
}
